import { PlugZap, RefreshCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Link } from '@inertiajs/react'

interface Props {
  busy: boolean
  cacheBusy: boolean
  onResolveCache: () => void
  accessManagement: { path: string; label: string }
}

export default function IntegrationsHeader({ busy, cacheBusy, onResolveCache, accessManagement }: Props) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-center gap-3">
        <PlugZap className="h-6 w-6 text-foreground" />
        <div>
          <h2 className="text-2xl font-bold text-foreground">Integrações Composio</h2>
          <p className="text-sm text-muted-foreground">Catálogo disponível no Composio e disponibilidade na StationZero.</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2"><Button variant="outline" size="sm" asChild><Link href={accessManagement.path}>{accessManagement.label}</Link></Button><Button type="button" variant="outline" size="sm" onClick={onResolveCache} disabled={busy}>
        <RefreshCcw className={`h-4 w-4 ${cacheBusy ? 'animate-spin' : ''}`} />
        Resolver cache
      </Button></div>
    </div>
  )
}
